import { RequestHeader } from "../constants/requestHeader";
import { ApiEndpoints } from "../constants/apiEndpoints";
import { jigenpassApi } from "../utils/apiClient";
import { logger } from "../utils/logger";

class AuthService {
  async checkSuperAdmin() {
    try {
      const data = await jigenpassApi.get(
        `${ApiEndpoints.AUTH}/bo/check-super-admin`,
        {
          timeout: 10000,
        },
      );

      logger.debug("Super admin check", {
        exists: data?.exists,
      });

      return {
        exists: data?.exists ?? false,
      };
    } catch (error) {
      logger.error("Super admin check failed", {
        status: error.status,
        message: error.message,
      });
      throw error;
    }
  }

  async signup({ email, password, username, firstName, lastName }) {
    try {
      const data = await jigenpassApi.post(
        `${ApiEndpoints.AUTH}/bo/signup`,
        { email, password, username, firstName, lastName },
        {
          timeout: 15000,
          headers: { [RequestHeader.CONTENT_TYPE]: "application/json" },
        },
      );

      logger.info("Super admin signup successful", { email });
      return data;
    } catch (error) {
      logger.error("Super admin signup failed", {
        email,
        status: error.status,
        message: error.message,
      });
      throw error;
    }
  }

  async checkAuth() {
    try {
      const data = await jigenpassApi.get(
        `${ApiEndpoints.AUTH}/bo/check-auth`,
        {
          timeout: 10000,
        },
      );

      logger.debug("Auth check successful", {
        user: data?.user,
      });

      return data;
    } catch (error) {
      logger.debug("Auth check failed", {
        status: error.status,
        message: error.message,
      });
      throw error;
    }
  }

  async login(email, password) {
    try {
      const data = await jigenpassApi.post(
        `${ApiEndpoints.AUTH}/bo/login`,
        { email, password },
        {
          timeout: 15000,
          headers: { [RequestHeader.CONTENT_TYPE]: "application/json" },
        },
      );

      logger.info("Login API call successful", { email });
      return data;
    } catch (error) {
      logger.error("Login API error:", {
        email,
        status: error.status,
        message: error.message,
      });
      throw error;
    }
  }

  async logout() {
    try {
      const data = await jigenpassApi.post(
        `${ApiEndpoints.AUTH}/bo/logout`,
        {},
        {
          timeout: 10000,
          headers: { [RequestHeader.CONTENT_TYPE]: "application/json" },
        },
      );

      logger.info("Logout successful");
      return data;
    } catch (error) {
      logger.error("Logout error:", error);
      throw error;
    }
  }

  async impersonate(userId, targetProject) {
    try {
      const data = await jigenpassApi.post(
        `${ApiEndpoints.AUTH}/bo/impersonate`,
        { userId, targetProject },
        { timeout: 15000 },
      );
      return data;
    } catch (error) {
      logger.error("Impersonation request failed", {
        userId,
        error: error.message,
      });
      throw error;
    }
  }
}

const authService = new AuthService();
export default authService;
export { authService };
